import { css, cx } from '@linaria/core';
import { CSSProperties } from 'react';
import { flex } from 'styles/utils/core';
import { baseTheme } from 'styles/utils';
import { CollapsibleBar, CollapsibleBarProps } from '../CollapsibleBar/CollapsibleBar';
interface ImageColorRecognizerViewProps {
  model: CF.API.Models.Model;
  modelOutput: CF.API.ModelOutputs.ModelOutput;
  collapsibleBarProps: Omit<CollapsibleBarProps, 'children' | 'isThresholdSliderVisible' | 'isModelVersionsDropdownVisible'>;
}
const colorClassName = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageColorRecognizerView_tsx-colorClassName-ccxzvdl";
export const ImageColorRecognizerView = ({
  model,
  modelOutput,
  collapsibleBarProps
}: ImageColorRecognizerViewProps): JSX.Element => {
  const {
    data
  } = modelOutput;
  const colorData = (data as CF.API.BaseColorsData);
  const stylesForColorSquare = (color: string): CSSProperties => ({
    height: 20,
    width: 20,
    borderRadius: 4,
    backgroundColor: color
  });
  const Color = ({
    color
  }: {
    color: CF.API.ColorsEntity;
  }) => <div className={colorClassName}>
      <div className="colorDetails">
        <div style={stylesForColorSquare(color.w3c.hex)} />
        <p>{color.raw_hex}</p>
      </div>
      <div className="colorHex">
        <p>{color.w3c.name}</p>
      </div>
      <div className="predictionValue">
        <p>{(color.value * 100).toPrecision(2)}%</p>
      </div>
    </div>;
  return <CollapsibleBar modelId={model.id} {...collapsibleBarProps} isModelVersionsDropdownVisible={false} isThresholdSliderVisible={false}>
      <div className={cx(flex.init, flex.direction.column)}>
        {colorData.colors?.map(color => <Color color={color} />)}
      </div>
    </CollapsibleBar>;
};

require("./ImageColorRecognizerView.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ImageColorRecognizerView.tsx");